import { render, staticRenderFns } from "./MobileReviews.vue?vue&type=template&id=826327bc&scoped=true&"
import script from "./MobileReviews.vue?vue&type=script&lang=js&"
export * from "./MobileReviews.vue?vue&type=script&lang=js&"
import style0 from "./MobileReviews.vue?vue&type=style&index=0&id=826327bc&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826327bc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CollectionReview: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/CollectionReview.vue').default})
